module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164016_HDR-removebg-preview-a83e80e46b1e2c9184a5890bd2b7d55b.png";